import { ROUTES } from "../shared/utils";

import { ProtectedRoute } from "../shared/pages";
import { AppLayout } from "../shared/layouts";

import { Projects } from "../features/projects";
import { AddPortfolio, Portfolio } from "../features/portfolio";
import { Dashboard, Overview } from "../features/projectOverview";
import { LiveProgress } from "../features/liveProgress";
import { AddProject } from "../features/projects";
import { ScheduleAndPlanning } from "../features/schedulePlanning";
import { Task } from "../features/tasks";
import { Queries } from "../features/queries";
import { RiskAndIssues } from "../features/riskAndIssues";
import { Documents } from "../features/artefacts/routes/Documents";
import { Commercials } from "../features/commercials/routes/Commercials";
import { StageGates } from "../features/stageGates/routes/StageGates";
import { MeetingManager } from "../features/meetingManager/routes/MeetingManager";
import { Procurement } from "../features/procurementPipeline";
import { Jeopardy } from "../features/jeopardy";
import { JeopardyDetail } from "../features/jeopardy";
import { ContractorOversight } from "../features/contractorOversight";
import { CommercialsDashboard } from "../features/commercialsDashboard";
import { BudgetCastPerformance } from "../features/budgetCastPerformance";
import { TrendsForecast } from "../features/trendsForecast";
import { CommitmentsExposure } from "../features/commimentsExposure";
import { RecurringTasks } from "../features/recurringTasks";
import { ProgrammeDashboard } from "../features/programmeDashboard";
import { MaterialRequests } from "../features/materialRequests";
import { ResourceRequests } from "../features/resourceRequests";
import { Import } from "../features/imports";
import { BatchDetail } from "../features/imports";
import { Export } from "../features/export";

export const operationalRoutes = [
  {
    element: <ProtectedRoute />,
    children: [
      {
        element: <AppLayout title="Live Progress" />,
        children: [{ path: ROUTES.LIVE_PROGRESS, element: <LiveProgress /> }],
      },
      {
        element: <AppLayout title="Portfolios" />,
        children: [{ path: ROUTES.PORTFOLIO, element: <Portfolio /> }],
      },
      {
        element: <AppLayout title="Add Portfolio" />,
        children: [{ path: ROUTES.ADD_PORTFOLIO, element: <AddPortfolio isEdit={false} /> }]
      },
      {
        element: <AppLayout title="Edit Portfolio" />,
        children: [{ path: ROUTES.EDIT_PORTFOLIO, element: <AddPortfolio isEdit={true} /> }]
      },
      {
        element: <AppLayout title="Portfolio Programme Dashboard" />,
        children: [{ path: ROUTES.PORTFOLIO_PROGRAMME_DASHBOARD, element: <ProgrammeDashboard /> }],
      },
      {
        element: <AppLayout title="Projects" />,
        children: [{ path: ROUTES.PROJECTS, element: <Projects /> }],
      },
      {
        element: <AppLayout title="Projects" />,
        children: [{ path: ROUTES.PORTFOLIO_PROJECTS, element: <Projects /> }],
      },
      {
        element: <AppLayout title="Projects" />,
        children: [{ path: ROUTES.PROJECTS_DETAILS_DASHBOARD, element: <Dashboard /> }],
      },
      {
        element: <AppLayout title="Projects" />,
        children: [{ path: ROUTES.PROJECTS_DETAILS_OVERVIEW, element: <Overview /> }],
      },
      {
        element: <AppLayout title="Projects" />,
        children: [{ path: ROUTES.PROJECTS_DETAILS_SCHEDULE_AND_PLANNING, element: <ScheduleAndPlanning /> }],
      },
      {
        element: <AppLayout title="Projects" />,
        children: [{ path: ROUTES.PROJECTS_DETAILS_STAGE_GATES, element: <StageGates /> }],
      },
      {
        element: <AppLayout title="Projects" />,
        children: [{ path: ROUTES.PROJECTS_DETAILS_RECURRING_TASKS, element: <RecurringTasks /> }],
      },
      {
        element: <AppLayout title="Projects" />,
        children: [{ path: ROUTES.PROJECTS_DETAILS_QUERIES, element: <Queries /> }],
      },
      {
        element: <AppLayout title="Projects" />,
        children: [{ path: ROUTES.PROJECTS_DETAILS_RISKS_AND_ISSUES, element: <RiskAndIssues /> }],
      },
      {
        element: <AppLayout title="Projects" />,
        children: [{ path: ROUTES.PROJECTS_DETAILS_COMMERICIALS, element: <Commercials /> }],
      },
      {
        element: <AppLayout title="Projects" />,
        children: [{ path: ROUTES.ADD_PROJECT, element: <AddProject isEdit={false} /> }],
      },
      {
        element: <AppLayout title="Projects" />,
        children: [{ path: ROUTES.EDIT_PROJECT, element: <AddProject isEdit={true} /> }],
      },
      {
        element: <AppLayout title="Projects" />,
        children: [{ path: ROUTES.PROJECTS_DETAILS_SCHEDULE_AND_PLANNING, element: <ScheduleAndPlanning /> }],
      },
      {
        element: <AppLayout title="Projects" />,
        children: [{ path: ROUTES.PORTFOLIO_PROJECTS_DETAILS_DASHBOARD, element: <Dashboard /> }],
      },
      {
        element: <AppLayout title="Projects" />,
        children: [{ path: ROUTES.PORTFOLIO_PROJECTS_DETAILS_OVERVIEW, element: <Overview /> }],
      },
      {
        element: <AppLayout title="Projects" />,
        children: [{ path: ROUTES.PORTFOLIO_PROJECTS_DETAILS_SCHEDULE_AND_PLANNING, element: <ScheduleAndPlanning /> }],
      },
      {
        element: <AppLayout title="Projects" />,
        children: [{ path: ROUTES.PORTFOLIO_PROJECTS_DETAILS_STAGE_GATES, element: <StageGates /> }],
      },
      {
        element: <AppLayout title="Projects" />,
        children: [{ path: ROUTES.PORTFOLIO_PROJECTS_DETAILS_RECURRING_TASKS, element: <RecurringTasks /> }],
      },
      {
        element: <AppLayout title="Projects" />,
        children: [{ path: ROUTES.PORTFOLIO_PROJECTS_DETAILS_QUERIES, element: <Queries /> }],
      },
      {
        element: <AppLayout title="Projects" />,
        children: [{ path: ROUTES.PORTFOLIO_PROJECTS_DETAILS_RISKS_AND_ISSUES, element: <RiskAndIssues /> }],
      },
      {
        element: <AppLayout title="Projects" />,
        children: [{ path: ROUTES.PORTFOLIO_PROJECTS_DETAILS_COMMERICIALS, element: <Commercials /> }],
      },
      {
        element: <AppLayout title="Projects" />,
        children: [{ path: ROUTES.PORTFOLIO_PROJECTS_DETAILS_SCHEDULE_AND_PLANNING, element: <ScheduleAndPlanning /> }],
      },
      {
        element: <AppLayout title="Tasks" />,
        children: [{ path: ROUTES.TASKS, element: <Task /> }],
      },
      {
        element: <AppLayout title="Queries" />,
        children: [{ path: ROUTES.QUERIES, element: <Queries /> }],
      },
      {
        element: <AppLayout title="Risk Dashboard" />,
        children: [{ path: ROUTES.RISK_DASHBOARD, element: <RiskAndIssues /> }],
      },
      {
        element: <AppLayout title="Meeting Manager" />,
        children: [{ path: ROUTES.MEETING_MANAGER, element: <MeetingManager /> }],
      },
      {
        element: <AppLayout title="Documents" />,
        children: [{ path: ROUTES.DOCUMENT_MANAGER, element: <Documents /> }],
      },
      {
        element: <AppLayout title="Projects" />,
        children: [{ path: ROUTES.PROJECTS_DETAILS_ARTEFACT_AND_DOCUMENTS, element: <Documents /> }],
      },
      {
        element: <AppLayout title="Projects" />,
        children: [{ path: ROUTES.PROJECTS_DETAILS_MATERIAL_REQUESTS, element: <MaterialRequests /> }],
      },
      {
        element: <AppLayout title="Projects" />,
        children: [{ path: ROUTES.PROJECTS_DETAILS_RESOURCE_REQUESTS, element: <ResourceRequests /> }],
      },
      {
        element: <AppLayout title="Procurement Pipeline" />,
        children: [{ path: ROUTES.PROCUREMENT_PIPELINE, element: <Procurement /> }],
      },
      {
        element: <AppLayout title="Jeopardy Manager" />,
        children: [{ path: ROUTES.JEOPARDY_MANAGER, element: <Jeopardy /> }],
      },
      {
        element: <AppLayout title="Jeopardy Details" />,
        children: [{ path: ROUTES.JEOPARDY_MANAGER_DETAILS, element: <JeopardyDetail /> }],
      },
      {
        element: <AppLayout title="Contractor Oversight" />,
        children: [{ path: ROUTES.CONTRACTOR_OVERSIGHT, element: <ContractorOversight /> }],
      },
      {
        element: <AppLayout title="Commercial Programme Dashboard" />,
        children: [{ path: ROUTES.COMMERCIAL_DASHBOARD, element: <CommercialsDashboard /> }],
      },
      {
        element: <AppLayout title="Budgets vs Actuals" />,
        children: [{ path: ROUTES.BUDGETS_VS_ACTUALS, element: <BudgetCastPerformance /> }],
      },
      {
        element: <AppLayout title="Commitments & Accruals" />,
        children: [{ path: ROUTES.COMMITMENTS_AND_ACCRUALS, element: <CommitmentsExposure /> }],
      },
      {
        element: <AppLayout title="Trends & Forecasts" />,
        children: [{ path: ROUTES.TRENDS_AND_FORECASTS, element: <TrendsForecast /> }],
      },
      {
        element: <AppLayout title="Import Manager" />,
        children: [{ path: ROUTES.IMPORT_MANAGER, element: <Import /> }],
      },
      {
        element: <AppLayout title="Import Batch Details" />,
        children: [{ path: ROUTES.IMPORT_BATCH_DETAIL, element: <BatchDetail /> }],
      },
       {
        element: <AppLayout title="Export" />,
        children: [{ path: ROUTES.EXPORT_MANAGER, element: <Export /> }],
      },
    ],
  },
];
